
<script>
export default {

    /** 上一页 **/
    prev() {
        const navbox=document.querySelector('.TTL-nav-content-box'); //导航盒子对象
        const boxwidth=Number(document.querySelector('.TTL-nav-content').clientWidth); //主题导航对象宽度
        const navboxwidth=Number(document.querySelector('.TTL-nav-content-all').clientWidth); //导航盒子宽度
        const left=Number(document.querySelector('.TTL-nav-content-box').offsetLeft); //导航盒子对象滑动宽度
        const lefts=left < 0 ? Math.abs(left) : 0;

        //盒子宽度大于主题宽度时，不滚动
        if(boxwidth >= navboxwidth) return false; 

        //主题宽度大于主题宽度时，进行滚动计算（剩余导航条宽度大于盒子宽度时滚动盒子宽度，反之则滚动剩余导航条宽度）
        const lastwidth=navboxwidth-lefts; //计算剩余导航条宽度
        //剩余宽度小于盒子宽度时也部做滑动处理
        if(boxwidth >= lastwidth) return false;

        const animalwidth=lastwidth >= boxwidth ? boxwidth : lastwidth;
        const animals=lefts+animalwidth;
        const animalswidth=animals > 0 ? '-'+animals : 0;
        navbox.style['margin-left']=animalswidth+'px';
    },


    /** 下一页 **/
    next() {
        const navbox=document.querySelector('.TTL-nav-content-box'); //导航盒子对象
        const boxwidth=Number(document.querySelector('.TTL-nav-content').clientWidth); //主题导航对象宽度
        const left=Number(document.querySelector('.TTL-nav-content-box').offsetLeft); //导航盒子对象滑动宽度
        const lefts=left < 0 ? Math.abs(left) : 0;
        if(lefts==0) return false; //滑动到头了，不处理

        //可滑动宽度大于盒子宽度时，取盒子宽度，反之直接滑到底
        const animalwidth=lefts > boxwidth ? '-'+(lefts-boxwidth) : 0;
        navbox.style['margin-left']=animalwidth+'px';
    },


    /** 具体nav点击情况处理 **/
    moveNav(index) {
        //获取滑块对象
        var navobj=document.querySelector('.TTL-nav-content-all');
        //获取滑块对象
        var navbox=document.querySelector('.TTL-nav-content-box'); //导航盒子对象
        //获取盒子宽度
        var boxobjwidth=Number(document.querySelector('.TTL-nav-content').clientWidth); //获取盒子宽度
        //获取当前滑块滑动宽度
        var left=Number(document.querySelector('.TTL-nav-content-box').offsetLeft); //滑块滑动宽度
        left=Math.abs(left);

        //获取当前label滑动长度的取值范围
        var navMin=Number(0);
        var navMax=Number(0);
        var navigationwidth=Number(0);
        var locanav=Number(0);
        for(var i=0;i < navobj.querySelectorAll('.TTL-nav-info').length; i++) {
            navigationwidth=Number(navobj.querySelectorAll('.TTL-nav-info')[i].clientWidth)+Number(10);
            if(index > i) navMin += navigationwidth;
            if(index >= i) navMax += navigationwidth;
            if(index==i) locanav=navigationwidth;
        }

        console.log('boxwidth:'+boxobjwidth);
        console.log('left:'+left);
        console.log('navMin:'+navMin);
        console.log('navMax:'+navMax);

        if(navMin >= left && left >= navMax - boxobjwidth) { //在显示范围之内不移动
            console.log('输出1');
            return false;
        }else if(navMin < left && navMax >= left) { //在左边但没完全显示
            var lastmax=navMax-left;
            var animal=left-(locanav-lastmax);
            animal=animal > 0 ? '-'+animal : 0;
            navbox.style['margin-left']=animal+'px';
            console.log('输出2');
        }else if(navMin >= left && navMin <= left + boxobjwidth) { //在右边但没有完全显示
            var lastmax=navMax - (left + boxobjwidth);
            var animal=left + lastmax;
            animal=animal > 0 ? '-'+animal : 0;
            navbox.style['margin-left']=animal+'px';
            console.log('输出3');
        }else {
            navMin=navMin > 0 ? '-'+navMin : 0;
            navbox.style['margin-left']=navMin+'px';
            console.log('输出4');
        }


    },


    /** 滚动复位 **/
    moveReset() {
        var navbox=document.querySelector('.TTL-nav-content-box'); //导航盒子对象
        navbox.style['margin-left']='0';
    },


}
</script>